// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inline-menu__item{display:inline-block;margin-right:2rem}.inline-menu__item:last-child{margin-right:0}.inline-menu__link{font-size:.875rem;color:#4a4a4a}.inline-menu__link:hover{color:#4a4a4a}", ""]);
// Exports
module.exports = exports;
